import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function About() {
  const {
    t
  } = useLanguage();
  return <section id="about" className="py-32 px-6 bg-bg-secondary" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-11">
          <div className="flex items-center gap-6 mb-12" data-id="element-12">
            <h2 className="text-3xl md:text-5xl font-serif text-white" data-id="element-13">
              {t('about.title')}
            </h2>
            <div className="h-px bg-gold flex-grow max-w-[100px] opacity-50" data-id="element-14"></div>
          </div>

          <div className="space-y-8 text-lg md:text-xl text-gray-300 font-light leading-relaxed" data-id="element-15">
            <p data-id="element-16">{t('about.p1')}</p>
            <p data-id="element-17">{t('about.p2')}</p>
            <p className="text-gold-light" data-id="element-18">{t('about.p3')}</p>
          </div>
        </motion.div>
      </div>
    </section>;
}